import { MenuSection } from "app/features/reporting/organisms/MenuSection";
import { View } from "ui/atoms/view";
import { Slot, useSegments } from "expo-router";
import GoBack from "ui/molecules/common/GoBack";
import { useCallback } from "react";

export default function FluidReportsLayout() {
  const segments = useSegments() as string[];
  const reportsPath = `/${segments.slice(0, 5).join("/")}`;

  const isSelected = useCallback(
    (endSegment: string) => {
      return segments.includes(endSegment);
    },
    [segments],
  );

  const fluidMenuOptions = [
    {
      label: "Fluid Intake",
      href: `./fluid-intake`,
      selected: isSelected("fluid-intake"),
    },
    {
      label: "Fluid Output",
      href: `./fluid-output`,
      selected: isSelected("fluid-output"),
    },
  ];

  return (
    <View className="resident-container">
      <View className="self-start mb-16">
        <GoBack path={reportsPath} />
      </View>
      <View className="flex-row">
        <View className="w-[220px] lg:w-[237px]">
          <MenuSection options={fluidMenuOptions} />
        </View>
        <View className="flex-1 ml-10">
          <Slot />
        </View>
      </View>
    </View>
  );
}
